"use strict";

exports.__esModule = true;
exports.MetricTableElement = MetricTableElement;
var _react = _interopRequireDefault(require("react"));
var _MetricDataTable = require("./MetricDataTable");
var _formatColumns = require("../../Core/DataTable/formatColumns");
var _FiltersController = require("../common/FiltersController");
var _MetricQueryGenerator = require("./MetricQueryGenerator");
var _MetricDataTableController = require("./MetricDataTableController");
var _SelectionContext = require("../../Core/SelectionContext");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _TimeContext = require("../../Time/TimeContext");
var _MaxBinLimitWrapper = require("../common/MaxBinLimitWrapper");
var _formatToPlantTime = require("../common/utils/formatToPlantTime");
var _MetricTableTargetsController = require("./MetricTableTargetsController");
var _MetricTableColumnController = require("./MetricTableColumnController");
var _MetricDropdown = require("./MetricDropdown");
var _excluded = ["columns", "columnProps"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var deleteTargetValueType = function deleteTargetValueType(data) {
  return data.map(function (targetedRow) {
    return targetedRow["target.value"] ? targetedRow : Object.assign({}, targetedRow, {
      "target.value.type": undefined
    });
  });
};
function MetricTableElement(props) {
  var _React$useState = _react["default"].useState(null),
    query = _React$useState[0],
    updateQuery = _React$useState[1];
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  var timezone = time.timezone;
  var dataRange = props.dataRange,
    children = props.children,
    fetchDataOnlyOnSelection = props.fetchDataOnlyOnSelection,
    showTargets = props.showTargets;
  var selection = _react["default"].useContext(_SelectionContext.SelectionContext);
  var columnProps = children.map(function (child) {
    return child.props;
  });
  var timeAggregation = columnProps.find(function (d) {
    return d.id === "workday";
  });
  var timeAggregationName = timeAggregation && timeAggregation.name || "";
  var shiftAggregation = columnProps.find(function (d) {
    return d.id === "shift";
  });
  var shiftAggregationName = shiftAggregation && shiftAggregation.name || "";
  var kindAggregation = columnProps.find(function (d) {
    return d.id === "kind";
  });
  var kindAggregationName = kindAggregation && kindAggregation.name || "";

  // TODO: how to do this cleanly, feels like a hack.
  // hour_of_day aggregation is also part of byTime aggregates, it has id workday, we need to change it to hour
  columnProps = columnProps.map(function (column) {
    if (column.id === "workday" && (column.name === _timeAggregationBinMapping.HOUR_PER_DAY || column.name === _timeAggregationBinMapping.HOUR_OF_DAY)) {
      return Object.assign({}, column, {
        id: "hour"
      });
    }
    return column;
  });
  if (selection.isSelectionEmpty(dataRange, fetchDataOnlyOnSelection)) {
    return /*#__PURE__*/_react["default"].createElement(_MetricDataTable.MetricDataTable, _extends({}, props, {
      query: query,
      columns: columnProps,
      data: [],
      loading: false,
      sortIndex: (0, _formatColumns.getSortIndex)(columnProps),
      noDataText: "Make selection to view data",
      additionalToolbarSelectors: /*#__PURE__*/_react["default"].createElement(_MetricDropdown.MetricDropdown, _extends({
        dataTestId: "MetricTableElement.MetricDropdown",
        multiple: true
      }, selectorProps))
    }));
  }
  var returnMetricDataTable = function returnMetricDataTable(_ref) {
    var props = _ref.props,
      query = _ref.query,
      data = _ref.data,
      loading = _ref.loading,
      reload = _ref.reload,
      selectorProps = _ref.selectorProps;
    return /*#__PURE__*/_react["default"].createElement(_MetricDataTable.MetricDataTable, _extends({}, props, {
      query: query,
      columns: columnProps,
      data: data,
      loading: loading,
      sortIndex: (0, _formatColumns.getSortIndex)(columnProps),
      reload: reload,
      selectedMetric: selectorProps == null ? void 0 : selectorProps.selected,
      additionalToolbarSelectors: /*#__PURE__*/_react["default"].createElement(_MetricDropdown.MetricDropdown, _extends({
        dataTestId: "MetricTableElement.MetricDropdown",
        multiple: true
      }, selectorProps))
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_MaxBinLimitWrapper.MaxBinLimitWrapper, {
    timeAggregationName: timeAggregationName
  }, /*#__PURE__*/_react["default"].createElement(_MetricTableColumnController.MetricTableColumnController, {
    columns: children,
    columnProps: columnProps
  }, function (_ref2) {
    var columns = _ref2.columns,
      columnProps = _ref2.columnProps,
      selectorProps = _objectWithoutPropertiesLoose(_ref2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_FiltersController.FiltersController, {
      dataRange: dataRange
    }, function (filters) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MetricQueryGenerator.MetricQueryGenerator, _extends({}, props, {
        query: query,
        filtersDict: filters,
        updateQuery: updateQuery
      }), columns), /*#__PURE__*/_react["default"].createElement(_MetricDataTableController.MetricDataTableController, _extends({
        query: query,
        columns: columnProps,
        filtersDict: filters
      }, props), function (_ref3) {
        var data = _ref3.data,
          loading = _ref3.loading,
          reload = _ref3.reload;
        if (data && data.length > 0 && timeAggregationName === _timeAggregationBinMapping.HOUR_PER_DAY) {
          data = (0, _formatToPlantTime.formatToPlantTime)({
            data: data,
            timezone: timezone,
            binName: "hour"
          });
        }
        return showTargets ? /*#__PURE__*/_react["default"].createElement(_MetricTableTargetsController.MetricTableTargetsController, {
          timeAggregationName: timeAggregationName,
          tableData: data,
          filters: filters,
          shiftAggregationName: shiftAggregationName,
          kindAggregationName: kindAggregationName,
          time: time
        }, function (_ref4) {
          var data = _ref4.data,
            loadingTarget = _ref4.loading;
          return returnMetricDataTable({
            props: Object.assign({}, props),
            query: query,
            columns: columnProps,
            data: deleteTargetValueType(data),
            loading: loading || loadingTarget,
            reload: reload,
            selectorProps: selectorProps
          });
        }) : returnMetricDataTable({
          props: Object.assign({}, props),
          query: query,
          columns: columnProps,
          data: data,
          loading: loading,
          reload: reload,
          selectorProps: selectorProps
        });
      }));
    });
  }));
}